import { render, staticRenderFns } from "./Image_Dialog.vue?vue&type=template&id=bd4e503a&"
import script from "./Image_Dialog.vue?vue&type=script&lang=js&"
export * from "./Image_Dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports